module.exports = __webpack_public_path__ + "img/Big_Icon_Pedlock.495a69ed.svg";